import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Octopus, OctopusResponseError } from '@maximizer/core/shared/domain';
import { Observable, map } from 'rxjs';
import { ContextService } from './context.service';

@Injectable()
export class ColumnSetupService {
  private readonly http = inject(HttpClient);
  private readonly context = inject(ContextService);

  getCurrentUserView(
    entityType: Octopus.EntityType,
  ): Observable<Octopus.ColumnSetup | null> {
    const request: Octopus.ColumnSetupViewReadRequest = {
      View: { EntityType: entityType },
    };

    return this.http
      .post<Octopus.ColumnSetupViewResponse>(
        `${this.context.api}${Octopus.Action.GET_CURRENT_USER_VIEW}`,
        request,
      )
      .pipe(map((response) => this.getColumnSetup(response)));
  }

  // The server saves a Rank-1 (default) view as a new Rank-10 view owned by the current user.
  setCurrentUserView(
    columnSetup: Octopus.ColumnSetup,
  ): Observable<Octopus.ColumnSetup | null> {
    const request: Octopus.ColumnSetupViewSaveRequest = {
      View: { ColumnSetup: columnSetup },
    };

    return this.http
      .post<Octopus.ColumnSetupViewResponse>(
        `${this.context.api}${Octopus.Action.SET_CURRENT_USER_VIEW}`,
        request,
      )
      .pipe(map((response) => this.getColumnSetup(response)));
  }

  private getColumnSetup(
    response: Octopus.ColumnSetupViewResponse,
  ): Octopus.ColumnSetup | null {
    if (response.Code !== Octopus.ResponseStatusCode.Successful) {
      throw OctopusResponseError.fromResponse(response);
    }

    return response.View?.ColumnSetup ?? null;
  }
}
